<template>
    <div class="productnew">
      <!--banner-->
      <div class="banner outer">
        <div class="inside1490">
           <h1 class="banner_title">易猎云招聘管理系统
            <span class="banner_rpo">RPO版</span>
           </h1>
           <p class="banner_txt">专为RPO场景设计，帮助人力资源企业进行招聘数<br/>字化转型，提升企业的招聘效率和市场竞争力</p>
        </div>
      </div>
      <!--全流程数字化管理-->
      <div class="process outer">
        <div class="inside1490">
          <h2>招聘全流程数字化管理</h2>
          <div class="serviceProcessChart">
            <ul class="cl">
              <li v-for="(yu, index) in serviceProcessChartList" :key="index">
                <h3><img :src="yu.serviceProcessChartimg"/></h3>
                <p>{{ yu.serviceProcessCharttext }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--图片文字排版1-->
      <div class="outer">
        <div class="inside1490 textimgbox">
          <img
            class="fl"
            style="width: 768px;height: 378px;margin-top: 122px;"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/pro_pic_01%402x-2.png"
          />
          <div class="fr">
            <h2 style="text-align: right;">快速搭建RPO特色人才库</h2>
            <p class="text_detail">自研简历解析与OCR引擎，精准识别简历<br/> 多维度简历智能搜索，高效筛选候选人<br/> 自定义标签设置，灵活复用简历</p>
          </div>
        </div>
      </div>
      <!--清除浮动-->
      <div class="clear"></div>
      <!--文字图片排版2-->
      <div class="outer">
        <div class="inside1490 imgtextbox">
          <div class="fl">
            <h2 style="text-align: left">内外部简历精准匹配与识别</h2>
            <p class="text_detail">识别简历库已有人才，提高招聘效率<br/> 候选人活跃时间提醒，提高沟通时效性<br/> 团队招呼提醒，避免重复沟通</p>
          </div>
          <img
            class="fr"
            style="width: 768px;height: 357px;margin-top: 120px;"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/pro_pic_02%402x-2.png"
          />
        </div>
      </div>
      <!--清除浮动-->
      <div class="clear"></div>
       <!--图片文字排版3-->
       <div class="outer">
        <div class="inside1490 textimgbox" style="height: 709px;">
          <img
            class="fl"
            style="width: 768px;height: 525px;margin-top: 122px;"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/new_pic_03%402x.png"
          />
          <div class="fr">
            <h2 style="text-align: right;">多角色招聘过程有序协同</h2>
            <p class="text_detail" style="width: 460px;">招聘顾问、项目经理、服务专员、企业管理<br/>者等多角色有序协同<br/> 支持面试扫码和入职扫码，入职自助填写花<br/>名册从招聘到入职全流程数字化 </p>
          </div>
        </div>
      </div>
      <!--清除浮动-->
      <div class="clear"></div>
       <!--文字图片排版4-->
       <div class="outer">
        <div class="inside1490 imgtextbox" style="height: 753px;">
          <div class="fl">
            <h2 style="text-align: left">多渠道统一管理</h2>
            <p class="text_detail" style="width: 350px;">支持主流招聘平台简历自动入库<br/> 支持内外部推荐以及渠道交付<br/> 支持自定义招聘渠道</p>
          </div>
          <img
            class="fr"
            style="width: 776px;height: 564px;margin-top: 120px;"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/up_pic_04%402x.png"
          />
        </div>
      </div>
      <!--清除浮动-->
      <div class="clear"></div>
      <!--图片文字排版5-->
      <div class="outer">
        <div class="inside1490 textimgbox" style="height: 837px;">
          <img
            class="fl"
            style="width: 788px;height: 617px;margin-top: 122px;"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/pro_pic_05%402x-2.png"
          />
          <div class="fr">
            <h2 style="text-align: left;">卓越的系统打通能力</h2>
            <p class="text_detail" style="width: 440px;">支持对接通讯外呼线路，一键外呼及录音<br/> 工作手机、个人微信、企业微信打通<br/> 开放系统API，自由对接内部系统</p>
          </div>
        </div>
      </div>
      <!--清除浮动-->
      <div class="clear"></div>
      <!--文字图片排版6-->
      <div class="outer">
        <div class="inside1490 imgtextbox" style="height: 615px;">
          <div class="fl">
            <h2 style="text-align: left">友好的招聘顾问使用体验</h2>
            <p class="text_detail" style="width: 450px;">不改变招聘顾问的工作习惯<br/> 支持在招聘平台上一键入库、外呼、评价<br/> 招聘平台端即可完成全部工作内容</p>
          </div>
          <img
            class="fr"
            style="width: 758px;height: 345px;margin-top: 120px;"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/pro_pic_06%402x.png"
          />
        </div>
      </div>
      <!--清除浮动-->
      <div class="clear"></div>
      <div class="security outer">
          <div class="inside1490 security_child">
            <div class="security_left"><img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_customer_service%402x.png"/></div>
            <div class="security_right">
              <p class="p1">即刻开启数字化招聘人效提升之旅</p>
              <div class="security_center" @click="trial()">申请试用</div>
            </div>
           
          </div>
      </div>
        <!--申请试用组件-->
    <populone v-if="windowflags" :isshow="windowflags" :selectId="''" :he="true" @handleChange="changewindows" />
    </div>
  </template>
  <script>
  import populone from "@/components/views/popul/populone";
  export default {
    name: "productnew",
    data() {
      return {
        windowflags: false,
        routeData:{},
        serviceProcessChartList: [
          {
            serviceProcessCharttext: "岗位投放",
            serviceProcessChartimg:
              "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/project_icon_post_delivery%402x.png",
          },
          {
            serviceProcessCharttext: "简历入库",
            serviceProcessChartimg:
              "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/project_icon_resume_warehousing%402x.png",
          },
          {
            serviceProcessCharttext: "人岗匹配",
            serviceProcessChartimg:
              "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/project_icon_man_post%20matching%402x.png",
          },
          {
            serviceProcessCharttext: "邀约",
            serviceProcessChartimg:
              "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/project_icon_invite%402x.png",
          },
          {
            serviceProcessCharttext: "面试",
            serviceProcessChartimg:
              "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/project_icon_interview%402x.png",
          },
          {
            serviceProcessCharttext: "入职",
            serviceProcessChartimg:
              "https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/project_icon_entry%402x.png",
          },
        ],
        type:1
      };
    },
    components: {
        populone,
    },
    mounted(){
    //   this.type= this.$route.params.id;
    //   console.log(this.type,'路由的值');
      if (Object.keys(this.$route.query).length) {
        this.routeData = this.$route.query;
      }
      const { u = "" } = this.routeData;
      if (!u) {
        console.log("WWWW");
        zhuge.track("官网产品页", {
          渠道: "pc",
          utm类型: "自然流量",
        });
      } else {
        zhuge.track("官网产品页", {
          渠道: "pc",
          utm类型: "驱动流量",
        });
      }
    },
    methods:{
      trial(){
        this.windowflags = true;
        },
        changewindows(value) {
         this.windowflags = value;
        },
    },
    metaInfo: {
        title: '易猎云产品-更适合RPO的免费招聘管理系统',
        meta: [
          {
            name: 'keywords',
            content: '易猎云，招聘管理系统，RPO，HRO，ATS，批量招聘，数字化'
          },
          {
            name: 'description',
            content: '易猎云招聘管理系统，RPO公司批量招聘数字化首选的招聘系统'
          }
        ]
    },
  };
  </script>
  <style lang="less" scoped>
  @import "~@/assets/css/style/index.less";
  .productnew {
    margin-top: 85px;
    .banner {
      width: 100%;
      height: 730px;
      background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/banner1%402x.png');
      background-repeat: no-repeat;
      background-size: 100%;
      padding-top: 230px;
      box-sizing: border-box;
      .banner_title{
        font-size: 60px;
        color: #1D2754;
        line-height: 112px;
      }
      .banner_rpo{
        display: inline-block;
        width: 80px;
        height: 34px;
        border-radius: 7px;
        border: 1px solid #5666FF;
        font-size: 20px;
        color: #5666FF;
        line-height: 34px;
        text-align: center;
        vertical-align: top;
        margin-top: 30px;
      }
      .banner_txt{
        font-size: 24px;
        color: #3A4D70;
        line-height: 40px;
      }
    }
    .process {
      width: 100%;
      height: 538px;
      background: #F2F5FB;
      padding-top: 79px;
      box-sizing: border-box;
      h2 {
        font-size: 48px;
        color: #1D2754;
        line-height: 48px;
        text-align: center;
      }
      .serviceProcessChart {
        ul {
          padding-top: 61px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          margin-left: 60px;
          li {
            width: 176px;
            height: 248px;
            background-color: #ffffff;
            border-radius: 10px;
            float: left;
            position: relative;
            h3 {
              width: 65px;
              height: 65px;
              background-color: #f8fafe;
              margin: 0 auto;
              margin-top: 46px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            p {
              text-align: center;
              margin-top: 52px;
              font-size: 22px;
              letter-spacing: -1px;
              color: #1d2754;
              line-height: 29px;
            }
          }
          li:last-child {
            margin-right: 0px;
          }
          li:after {
            content: "";
            position: absolute;
            display: inline-block;
            width: 47px;
            height: 19px;
            background-image: url("https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/mk_arrow_to_right.gif");
            background-repeat: no-repeat;
            background-size: 100%;
            right: -55px;
            top: 50%;
            transform: translateY(-50%);
          }
          li:last-child:after {
            content: "";
            width: 0;
            height: 0;
            border: 0;
          }
        }
      }
    }
    .textimgbox {
      width: 1490px;
      height: 610px;
      border-bottom: solid 1px #E4E6EE;
      h2 {
        font-size: 42px;
        margin-top: 126px;
        font-weight: 500;
        color: #1d2754;
        line-height: 48px;
      }
      .text_detail{
        width: 453px;
        font-size: 24px;
        color: #7087A6;
        line-height: 42px;
        margin-top: 31px;
      }
    }
    .clear {
      clear: both;
    }
    .imgtextbox {
      width: 1490px;
      height: 610px;
      border-bottom: solid 1px #E4E6EE;
      h2 {
        font-size: 42px;
        margin-top: 120px;
        font-weight: 500;
        color: #1d2754;
        line-height: 48px;
      }
      .text_detail{
        width: 408px;
        font-size: 24px;
        color: #7087A6;
        line-height: 42px;
        margin-top: 31px;
      }
    }
    .security{
      width: 100%;
      height: 277px;
      background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/bg_01%402x.png');
      background-repeat: no-repeat;
      background-size: 100% 102%;
      padding-top: 53px;
      box-sizing: border-box;
      .security_child{
        display: flex;
        .security_left{
            margin-left: 197px;
              img{
                width: 145px;
                height: 128px;
              }
        }
        .security_right{
             margin-left: 37px;
              .p1{
              display: inline-block;
              font-size: 48px;
              font-weight: 500;
              color: #ffffff;
              text-align: left;
              margin-top: 47px;
          }
        }
        .security_center{
          width: 158px;
          height: 66px;
          background: #FFFFFF;
          border-radius: 7px;
          line-height: 66px;
          text-align: center;
          font-size: 24px;
          color: #215FFF;
          cursor: pointer;
          margin: 0 auto;
          margin-top: 40px;
        }
      }
    }
  }
  </style>



// WEBPACK FOOTER //
// src/components/pages/product/productnew.vue